<template>
  <div class="count-down-num" >
    <div class="num-text">
      <span>{{num}}</span>
    </div>
    <!-- <div class="num-bg num-bg-top"></div>
    <div class="num-bg num-bg-bottom"></div>
    <div class="num-dot num-dot-left" :style="{background: bgColor}">
    </div>
    <div class="num-dot num-dot-right" :style="{background: bgColor}">
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    num: {
      type: String,
      default: '',
    },
    bgColor: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="less" scoped>
  .count-down-num {
    position: relative;
    width: 82px;
    height: 74px;

    .num-bg {
      position: absolute;
      width: 100%;
      height: 36px;
      left: 0;
      opacity: 0.4;
      background-image: linear-gradient(-180deg, #FFFFFF 0%, rgba(255,255,255,0.30) 50%);
      border-radius:4px;

      &.num-bg-top {
        top: 0;
      }
      &.num-bg-bottom {
        bottom: 0;
      }
    }

    .num-dot {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 8px;
      height: 14px;
      border-radius: 4px;
      &.num-dot-left {
        left: -4px;
      }
      &.num-dot-right {
        right: -4px;
      }
      &:after{
        position: absolute;
        top: 2px;
        left: 2px;
        content: '';
        display: inline-block;
        border-radius: 4px;
        width: 4px;
        height: 10px;
        background: rgba(255,255,255,0.30);
      }
    }

    .num-text {
      font-family: DINAlternate-Bold;
      font-size: 66px;
      line-height: 66px;
      text-align: center;
      color: #000;
    }
  }
</style>
